import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSubmissions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('sales/sales-submission/changi', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
